<script>
export default {
  name: 'BaseButton',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'md',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullwidth: {
      type: Boolean,
      default: false,
    },
    mdFullwidth: {
      type: Boolean,
      default: true,
    },
    xlFullwidth: {
      type: Boolean,
      default: true,
    },
    forIcon: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    to: [String, Object],
    selfEnd: {
      type: Boolean,
      default: true
    },
    customHeight: String,
    href: String
  },
  emits: ['click'],
  computed: {
    style: function () {
      const colors = {
        white: 'bg-white border-gray-300 text-gray-700 focus:ring-green-500',
        primary:
          'bg-green-600 focus:ring-green-500 hover:bg-green-700 text-white',
        success:
          'bg-green-600 focus:ring-green-500 hover:bg-green-700 text-white',
        secondary:
          'focus:outline-none text-white bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-500 font-medium rounded-lg dark:focus:ring-yellow-900',
        danger: 'bg-red-600 focus:ring-red-500 hover:bg-red-700 text-white',
        'danger-secondary': 'bg-red-100 border-red-300 focus:ring-red-500 hover:bg-red-200 text-red-500',
        warning:
          'bg-yellow-600 focus:ring-yellow-500 hover:bg-yellow-700 text-white',
        transparent:
          'bg-white-600 ml-3 rounded-md border border-gray-300 py-2 font-medium text-gray-700 shadow-sm hover:bg-white hover:shadow-lg',
        gray: 'bg-gray-200 text-gray-600 border-gray-400 focus:ring-0',
        purplefortheme: 'hover:bg-purple-700'
      };
      const sizes = {
        sm: 'h-8 px-2 text-xs rounded',
        md: ['px-3 text-sm rounded-md', this.customHeight ?? 'h-10'],
      };

      if (this.forIcon) {
        return {
          default: 'hover:bg-gray-200 p-1.5 rounded-full',
        };
      }

      return {
        color: [colors[this.color]],
        size: sizes[this.size],
        base: [
          this.fullwidth ? this.mdFullwidth ? this.xlFullwidth ? 'w-full' : 'w-full xl:w-auto' : 'w-full md:w-auto' : '',
          this.shadow ? 'shadow-sm' : '',
          'text-center justify-center'
        ],
        default: [
          this.selfEnd ? 'self-end' : '',
          'focus:outline-none inline-flex items-center gap-2 border font-medium leading-4 focus:ring-2 focus:ring-offset-2 disabled:cursor-default disabled:opacity-50 whitespace-nowrap'
        ]
      };
    },
  },
  methods: {
    handleClick: function () {
      if (this.href) {
        window.location.href = this.href
      }
      if (this.to) {
        this.$router.push(this.to);
      }
      this.$emit('click');
    },
  },
};
</script>

<template>
  <button
    v-if="!to"
    :class="[style.default, style.color, style.size, style.base]"
    :disabled="loading || disabled"
    v-on:click="handleClick"
  >
    <Icon
      icon="eos-icons:loading"
      v-if="loading"
      aria-hidden="true"
      class="text-white-200 inline h-4 w-4 animate-spin"
    />
    <slot />
  </button>
  <a
    v-else-if="href"
    :href="href"
    :class="[style.default, style.color, style.size, style.base]"
    :disabled="loading || disabled"
  >
    <Icon
      icon="eos-icons:loading"
      v-if="loading"
      aria-hidden="true"
      class="text-white-200 inline h-4 w-4 animate-spin"
    />
    <slot />
  </a>
  <router-link
    v-else
    :to="to"
    :class="[style.default, style.color, style.size, style.base]"
    :disabled="loading || disabled"
    v-on:click="handleClick"
  >
    <Icon
      icon="eos-icons:loading"
      v-if="loading"
      aria-hidden="true"
      class="text-white-200 inline h-4 w-4 animate-spin"
    />
    <slot />
  </router-link>
</template>
